import { render, staticRenderFns } from "./AddTruckModal.vue?vue&type=template&id=488c6406"
import script from "./AddTruckModal.vue?vue&type=script&lang=ts"
export * from "./AddTruckModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports